module.exports = __webpack_public_path__ + "static/media/4.6757f54c.jpg";